import styled from "styled-components";
import { typographyMixin } from "../../typography";
import { TitleProps } from "./Title.types";

type StyledTitleProps = Pick<TitleProps, "theme" | "variant" | "isLive" | "allowTextWrap" >;

export const StyledTitleBar = styled.div<StyledTitleProps>`
  ${typographyMixin}

  margin-bottom: 0.2rem;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  color: #fff;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  background-color: ${(props) => props.theme.primaryColor};
  color: ${(props) => props.theme.textOnPrimaryColor};

  // sets color if a variant is passed by variant name
  background-color: ${(props) => props.variant && props.theme[props.variant]};
  color: ${(props) => props.variant && "#fff"};
  color: ${(props) => props.variant === "muted" && "#36383d"};
`;

export const StyledTitlePlain = styled.div<StyledTitleProps>`
  ${typographyMixin}

  font-weight: 500;
  line-height: 1.2;
  margin-bottom: 0.5rem;
`;

export const StyledTitleDivider = styled.div<StyledTitleProps>`
  ${typographyMixin}

  display: flex;
  flex: row;
  align-items: center;
  text-transform: uppercase;
  text-align: center;
  line-height: 1.2;
  margin: 0.2rem 0;
  color: #36383d;
  white-space: ${(p)=> p.allowTextWrap ? "wrap" : "nowrap"};

  &:before {

    content: "";
    flex: 1 1 30%;
    display: block;
    height: 0.2rem;

    background-color: ${(props) => props.theme.primaryColor};

    // sets color if a variant is passed by variant name
    background-color: ${(props) => props.variant && props.theme[props.variant]};

    box-sizing: border-box;
    margin-right: 0.75rem;
  }

  &:after {
    content: "";
    flex: 1 1 30%;
    display: block;
    height: 0.2rem;
    background-color: ${(props) => props.theme.primaryColor};

    // sets color if a variant is passed by variant name
    background-color: ${(props) => props.variant && props.theme[props.variant]};

    box-sizing: border-box;
    margin-left: 0.75rem; 
  }
`;

export const StyledTitleDividerLineOnly = styled.hr<StyledTitleProps>`
  border: none;
  border-top: 0.2rem ${(props) => props.theme.primaryColor} solid;
  margin: 0.2rem 0;

  // sets color if a variant is passed by variant name - not working as intended.
  /* border-top: 0.2rem ${(props) => props.variant && props.theme[props.variant]} solid; */
`;

export const StyledTitleBar2 = styled.div<StyledTitleProps>`
  ${typographyMixin}

  display: flex;
  justify-content: center;
  margin-bottom: 0.2rem;
  padding: 0.5rem 1rem;
  background-color: rgba(54, 56, 61, 0.05);
  border-radius: 0.25rem;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-transform: uppercase;

  background-color: ${(props) => props.theme.primaryColor};

  color: ${(props) => props.theme.textOnPrimaryColor};

  // sets color if a variant is passed by variant name
  background-color: ${(props) => props.variant && props.theme[props.variant]};
  background-color: ${(props) => props.variant === "muted" && "#36383d0d"};
  
  color: ${(props) => props.variant && "#fff"};
  color: ${(props) => props.variant === "muted" && "#36383d"};
  color: ${(props) => props.isLive && "#007aff"}
`;
